export default {"src":"/_next/static/media/group2.15bdaf6e.svg","height":12,"width":13,"blurWidth":0,"blurHeight":0};